import { render, staticRenderFns } from "./DWVisual.vue?vue&type=template&id=58d80325&scoped=true&"
import script from "./DWVisual.vue?vue&type=script&lang=js&"
export * from "./DWVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d80325",
  null
  
)

export default component.exports